import React, { useState, useEffect } from 'react';
import { Star, Send, CheckCircle2 } from 'lucide-react';
import Header from './Header';
import { supabase } from '../../../supabaseClient';
import VideoListView from '../components/VideoListView';
import FaqSection from './FaqSection';
import WelcomeModal from './WelcomeModal';

interface HomeWelcomeViewProps {
  onNavigateToMovies: () => void;
  onSelectVideo?: (videoId: string) => void; // 👈 ADICIONE ESTA LINHA
}


// 👈 ADICIONE O onSelectVideo AQUI DENTRO DAS CHAVES
export default function HomeWelcomeView({ onNavigateToMovies, onSelectVideo }: HomeWelcomeViewProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Estados para o formulário de feedback no final da página
  const [nome, setNome] = useState('');
  const [tipo, setTipo] = useState('elogio');
  const [mensagem, setMensagem] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleSubmitFeedback = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim() || !mensagem.trim()) return;

    try {
      const { error } = await supabase
        .from('feedbacks')
        .insert([{ nome, tipo, mensagem }]);

      if (error) {
        console.error('Erro ao enviar feedback:', error.message);
        alert('Não foi possível enviar agora. Tente novamente mais tarde.');
        return;
      }

      setEnviado(true);
      setTimeout(() => {
        setEnviado(false);
        setNome('');
        setMensagem('');
      }, 4000);
    } catch (err) {
      console.error('Erro inesperado:', err);
    }
  };

  // Lista completa de recursos e imagens usando require para garantir o carregamento pelo Metro
  const features = [
    {
      imagem: require('../../../assets/galeriadevideos.webp'),
      titulo: 'Uma Galeria de Vídeos pra Maratonar',
      descricao: 'Sabe aquele momento que você quer só deitar e dar boas risadas ou curtir um bom filme? Separamos os melhores vídeos pra você assistir sozinho ou com a galera, sem complicação!'
    },
    {
      imagem: require('../../../assets/pcecelular.webp'),
      titulo: 'Roda Liso no Celular e no PC',
      descricao: 'O Doisplay foi feito sob medida pra rodar leve na palma da sua mão ou na tela grande do computador. De qualquer lugar do Brasil, você assiste sem travamentos.'
    },
    {
      imagem: require('../../../assets/casal.webp'),
      titulo: 'Perfeito para Curtir a Dois',
      descricao: 'A distância aperta, mas a tecnologia une! Assista juntinho daquele alguém especial mesmo estando em lugares diferentes, transformando a tela em um verdadeiro encontro.'
    },
    {
      imagem: require('../../../assets/familia.webp'),
      titulo: 'Alegria Garantida pra Família Toda',
      descricao: 'Reúne a criançada, o mozão ou a família no sofá e aproveitem momentos inesquecíveis com conteúdos leves, seguros e selecionados com carinho.'
    },
    {
      imagem: require('../../../assets/mulher-no-sofa (1).webp'),
      titulo: 'Totalmente Gratuito no Brasil (Versão Beta)',
      descricao: 'Isso mesmo que você ouviu! Aproveite tudo 100% de graça enquanto estamos na versão Beta. Estamos crescendo a cada dia com a sua força e apoio.'
    },
    {
      imagem: require('../../../assets/onibuscomcasal.webp'),
      titulo: 'Leve o Lazer com Você Onde For',
      descricao: 'Tá no ônibus voltando do trampo, na fila ou viajando? Dá o play e aproveite seu tempo livre com conteúdos que alegram o seu dia a dia.'
    }
  ];

  // Reaproveita os 5 primeiros itens para o banner rotativo do topo
  const bannerItems = features.slice(0, 5);

  // Efeito para rotacionar o banner do topo automaticamente a cada 4.5 segundos
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % bannerItems.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [bannerItems.length]);

  const current = bannerItems[currentIndex];

  return (
    <div style={{ backgroundColor: '#000000', color: '#fff', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', display: 'flex', flexDirection: 'column', overflowX: 'hidden' }}>
      
      {/* Modal de Boas-Vindas Isolado */}
      <WelcomeModal />
      {/* Header limpo sem lupa */}
      <Header hideSearch={true} currentTab="inicio" onSelectVideo={onSelectVideo} /> {/* 👈 ADICIONE AQUI */}

      {/* BANNER ROTATIVO NO TOPO COM TÍTULO ALINHADO À ESQUERDA (Estilo Streaming) */}
      <div style={{ 
        position: 'relative', 
        width: '100%', 
        minHeight: '75vh',
        display: 'flex', 
        alignItems: 'center',
        padding: '60px 50px',
        backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.94) 25%, rgba(0,0,0,0.7) 60%, rgba(0,0,0,0.3) 100%), url(${current.imagem})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'background-image 0.8s ease-in-out',
        boxSizing: 'border-box'
      }}>
        
        {/* Alinhado totalmente à esquerda, sem centralizar */}
        <div style={{ maxWidth: '650px', width: '100%', zIndex: 2, textAlign: 'left' }}>
          <span style={{ color: '#E50914', fontWeight: 'bold', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '2px' }}>
            Doisplay • Versão Beta 🇧🇷
          </span>
          
          <h1 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: '900', lineHeight: '1.1', margin: '12px 0 20px 0', color: '#fff' }}>
            {current.titulo}
          </h1>

          <p style={{ fontSize: 'clamp(15px, 2vw, 17px)', color: '#ccc', lineHeight: '1.6', margin: 0 }}>
            {current.descricao}
          </p>

          {/* Indicadores do banner rotativo */}
          <div style={{ display: 'flex', gap: '8px', marginTop: '30px' }}>
            {bannerItems.map((_, idx) => (
              <div 
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                style={{
                  width: idx === currentIndex ? '28px' : '8px',
                  height: '8px',
                  borderRadius: '4px',
                  backgroundColor: idx === currentIndex ? '#E50914' : 'rgba(255,255,255,0.4)',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* SEÇÃO ABAIXO DO BANNER: CARDS EXPLICATIVOS LADO A LADO */}
      <section style={{ backgroundColor: '#050505', padding: '70px 20px', borderTop: '1px solid #222' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <span style={{ color: '#E50914', fontWeight: 'bold', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '2px' }}>
              Feito para os Brasileiros 🇧🇷
            </span>
            <h2 style={{ fontSize: 'clamp(26px, 4vw, 38px)', fontWeight: '900', marginTop: '10px' }}>
              Por que todo mundo tá curtindo o Doisplay?
            </h2>
            <p style={{ color: '#aaa', fontSize: '15px', maxWidth: '600px', margin: '15px auto 0 auto', lineHeight: '1.6' }}>
              Dá uma olhada em tudo o que preparamos para o seu dia a dia ficar muito mais divertido e leve.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '30px', marginBottom: '70px' }}>
            {features.map((item, index) => (
              <div 
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: index % 2 === 0 ? 'row' : 'row-reverse',
                  alignItems: 'center',
                  gap: '30px',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  backgroundColor: '#111',
                  padding: '24px',
                  borderRadius: '14px',
                  border: '1px solid #222'
                }}
              >
                <div style={{ flex: '1 1 260px', maxWidth: '360px', textAlign: 'center' }}>
                  <img 
                    src={item.imagem} 
                    alt={item.titulo}
                    style={{
                      width: '100%',
                      height: '200px',
                      borderRadius: '10px',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.7)',
                      border: '1px solid #333',
                      objectFit: 'cover'
                    }}
                  />
                </div>

                <div style={{ flex: '1 1 280px', maxWidth: '480px' }}>
                  <h3 style={{ fontSize: '20px', fontWeight: '800', marginBottom: '12px', color: '#fff' }}>
                    {item.titulo}
                  </h3>
                  <p style={{ fontSize: '14px', color: '#bbb', lineHeight: '1.6', margin: 0 }}>
                    {item.descricao}
                  </p>
                </div>
              </div>
            ))}
          </div>
<FaqSection/>
          {/* CAMPO DE FEEDBACK NO FINAL */}
<div style={{ 
  backgroundColor: '#0f0f0f', 
  padding: '40px 30px', 
  borderRadius: '16px', 
  border: '1px solid #262626',
  textAlign: 'center',
  width: '100%',
  boxSizing: 'border-box'
}}>
  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'rgba(229, 9, 20, 0.15)', color: '#E50914', padding: '6px 16px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold', marginBottom: '15px' }}>
    <Star size={16} fill="#E50914" /> Sua opinião vale ouro
  </div>

  <h3 style={{ fontSize: '24px', fontWeight: '800', marginBottom: '10px', color: '#fff' }}>
    Deixe seu Feedback, Elogio ou Sugestão
  </h3>
  <p style={{ fontSize: '14px', color: '#aaa', lineHeight: '1.5', marginBottom: '30px', maxWidth: '550px', margin: '0 auto 30px auto' }}>
    Explorou o site? Conta pra gente o que achou! Estamos em versão Beta e melhorando a cada dia com a sua ajuda.
  </p>

  {enviado ? (
    <div style={{ 
      backgroundColor: 'rgba(34, 197, 94, 0.1)', border: '1px solid #22c55e', 
      padding: '25px', borderRadius: '8px', color: '#22c55e', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' 
    }}>
      <CheckCircle2 size={32} />
      <h4 style={{ margin: 0, fontSize: '16px' }}>Feedback enviado com sucesso!</h4>
      <p style={{ margin: 0, fontSize: '13px', color: '#bbb' }}>Muito obrigado por fortalecer o Doisplay!</p>
    </div>
  ) : (
    <form onSubmit={handleSubmitFeedback} style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '600px', margin: '0 auto' }}>
      
      <div>
        <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#ccc', marginBottom: '6px' }}>
          Seu Nome ou Apelido
        </label>
        <input 
          type="text" 
          value={nome} 
          onChange={(e) => setNome(e.target.value)}
          placeholder="Ex: João da Silva"
          required
          style={{
            width: '100%', padding: '12px 14px', backgroundColor: '#050505', border: '1px solid #333',
            borderRadius: '6px', color: '#fff', fontSize: '14px', outline: 'none', boxSizing: 'border-box'
          }}
        />
      </div>

      <div>
        <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#ccc', marginBottom: '6px' }}>
          O que você quer mandar?
        </label>
        <select 
          value={tipo} 
          onChange={(e) => setTipo(e.target.value)}
          style={{
            width: '100%', padding: '12px 14px', backgroundColor: '#050505', border: '1px solid #333',
            borderRadius: '6px', color: '#fff', fontSize: '14px', outline: 'none', boxSizing: 'border-box', cursor: 'pointer'
          }}
        >
          <option value="elogio">⭐ Elogio</option>
          <option value="sugestao">💡 Sugestão de Melhoria</option>
          <option value="reclamacao">⚠️ Reclamação / Bug</option>
          <option value="outro">💬 Outro</option>
        </select>
      </div>

      <div>
        <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#ccc', marginBottom: '6px' }}>
          Sua Mensagem
        </label>
        <textarea 
          value={mensagem} 
          onChange={(e) => setMensagem(e.target.value)}
          placeholder="Escreva sua avaliação, elogio ou o que podemos melhorar..."
          rows={3}
          required
          style={{
            width: '100%', padding: '12px 14px', backgroundColor: '#050505', border: '1px solid #333',
            borderRadius: '6px', color: '#fff', fontSize: '14px', outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit'
          }}
        />
      </div>

      <button 
        type="submit"
        style={{
          backgroundColor: '#E50914', color: '#fff', border: 'none', padding: '13px',
          borderRadius: '6px', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'background 0.2s', marginTop: '5px'
        }}
      >
        <Send size={15} /> Enviar Mensagem
      </button>

    </form>
  )}
</div>

        </div>
      </section>
      

    </div>
  );
}
